import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { useI18nContext } from '@/i18n/i18n-react';
import { mobileLayer } from '@/lib/mobile-layer';

/**
 * Confirmation before the hard delete (PUSH-04 AC 4): "Cancelar campanha?
 * Ela não será enviada e não poderá ser recuperada." Stays open while the
 * request runs (confirm disabled); the caller closes it when it settles.
 */
export function CancelCampaignDialog({
  open,
  onOpenChange,
  campaignName,
  isPending,
  onConfirm,
}: {
  open: boolean;
  onOpenChange(open: boolean): void;
  campaignName: string;
  isPending: boolean;
  onConfirm(): void;
}) {
  const { LL } = useI18nContext();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {LL.campaigns.cancelDialog.title()}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {LL.campaigns.cancelDialog.description()}
          </AlertDialogDescription>
          <p className="truncate text-sm font-medium">{campaignName}</p>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className={mobileLayer.touch} disabled={isPending}>
            {LL.campaigns.cancelDialog.back()}
          </AlertDialogCancel>
          <Button
            type="button"
            variant="destructive"
            className={mobileLayer.touch}
            disabled={isPending}
            onClick={onConfirm}
          >
            {isPending
              ? LL.campaigns.cancelDialog.cancelling()
              : LL.campaigns.cancelDialog.confirm()}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
